export const factoryIntlNumberFormat = (
    locale: string,
    props: Partial<Intl.NumberFormatOptions> = {},
) => new Intl.NumberFormat(
    locale.replace('_', '-'),
    {
        style: 'decimal',
        ...props,
    },
);
